import { VenueDetailsOverviewEndKey } from 'src/i18next';

export type VenueCompsTableRowType = {
  label: VenueDetailsOverviewEndKey<'VENUE_COMPS.ROWS'>;
  accessor: 'venueComps';
};

export const venueCompsRows: VenueCompsTableRowType[] = [
  {
    label: 'COMPS',
    accessor: 'venueComps',
  },
];

